$(document).ready(() => {

    InitializeFooterReadMore();
    InitializeFooterReadLess();

})


const InitializeFooterReadMore = () => {
    $("#FooterReadMore").append("<i class='fa fa-chevron-down'></i>");

    $("#FooterReadMore").on("click", () => {
        if (!$("#FooterReadMoreWrapper").is(":animated")) {
            $("#FooterReadMoreWrapper").show(300, () => {
                $("#FooterReadMoreWrapper").data("expanded", true);
            });
            $("#FooterReadMore").hide(100, () => {
            });
            $("#FooterReadLess").show(100, () => {
            });
        }
        console.log("InitializeFooterReadMore");
    });
}
const InitializeFooterReadLess = () => {
    $("#FooterReadLess").append("<i class='fa fa-chevron-up'></i>");
    $("#FooterReadLess").on("click", () => {
        if (!$("#FooterReadMoreWrapper").is(":animated")) {
            $("#FooterReadMoreWrapper").hide(300, () => {
                $("#FooterReadMoreWrapper").data("expanded", false);
            });
            $("#FooterReadMore").show(100, () => {
            });
            $("#FooterReadLess").hide(100, () => {
            });
        }
        console.log("InitializeFooterReadMore");
    });
}
